export default 'remoteConfig';
